import { getBookmarkReferenceAssets } from '../assetLibraryAssetsLoad';
import { resolveAssetBookmarkedState } from '../assetLibraryGroupIds';
import { useStore } from '../assetLibraryStore';
import { useAssetLibraryAssetActions } from '../hooks/useAssetLibraryAssetActions';
import type { AssetLibraryDisplayItem } from '../utils';
import AssetLibraryCardBookmarkButton from './AssetLibraryCardBookmarkButton';
import AssetLibraryCardMoreMenu from './AssetLibraryCardMoreMenu';
import AssetLibraryCardSelectionControl from './AssetLibraryCardSelectionControl';

export interface AssetLibraryCardThumbnailOverlayProps {
  asset: AssetLibraryDisplayItem;
  embedded: boolean;
  isHovered: boolean;
  isGroupDetailItem?: boolean;
  bulkSelectionEnabled?: boolean;
  showBookmark?: boolean;
  selected?: boolean;
  onClick?: () => void;
  onToggleSelection?: () => void;
}

export default function AssetLibraryCardThumbnailOverlay({
  asset,
  embedded,
  isHovered,
  isGroupDetailItem = false,
  bulkSelectionEnabled = false,
  showBookmark = false,
  selected = false,
  onClick,
  onToggleSelection,
}: AssetLibraryCardThumbnailOverlayProps) {
  const store = useStore();
  const { libraryView } = store.state;
  const { toggleBookmark, requestMoveToTrash, requestRestoreFromTrash } =
    useAssetLibraryAssetActions();
  const isBookmarked = resolveAssetBookmarkedState(
    asset,
    getBookmarkReferenceAssets(store.state),
  );

  return (
    <>
      {bulkSelectionEnabled && onToggleSelection ? (
        <AssetLibraryCardSelectionControl
          selected={selected}
          visible={isHovered}
          onToggle={onToggleSelection}
        />
      ) : null}
      <div className="absolute top-2 right-2 z-10 flex items-center gap-1">
        <AssetLibraryCardMoreMenu
          asset={asset}
          embedded={embedded}
          visible={isHovered}
          isGroupDetailItem={isGroupDetailItem}
          onClick={onClick}
          onMoveToTrash={() => requestMoveToTrash(asset)}
          onMoveToLibrary={
            libraryView === 'trash'
              ? () => {
                  void requestRestoreFromTrash(asset);
                }
              : undefined
          }
        />
        {showBookmark ? (
          <AssetLibraryCardBookmarkButton
            visible={isHovered}
            isBookmarked={isBookmarked}
            onToggle={() => {
              void toggleBookmark(asset);
            }}
          />
        ) : null}
      </div>
    </>
  );
}
